// extracted by mini-css-extract-plugin
export default {"cardPreview":"styles_cardPreview__iznp2","cardPreview_number":"styles_cardPreview_number__H0dQU","cardPreview_expInfo":"styles_cardPreview_expInfo__LIlVw"};